import { render, staticRenderFns } from "./warehousing-vehicle-report.vue?vue&type=template&id=60c0a655"
import script from "./warehousing-vehicle-report.vue?vue&type=script&lang=ts"
export * from "./warehousing-vehicle-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports